import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Reveal } from "../components/Reveal";
import { Gallery } from "../components/Gallery";
import { useSeo } from "../hooks/useSeo";
import { IMG } from "../data/content";

/* ---------- Gallery data ----------
   Platzhalter – die finalen Eventbilder werden nachgeliefert und hier
   einfach pro Slot als { src: "URL", alt: "..." } eingetragen.
   Namensschema: Block{g}-{n}.jpg  (g = Galerie 1-3, n = Bild 1-9) */
const JUBILAEUM_BILDER = {
  1: [
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/4szw8bwv_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block1-1.jpg", alt: "50 Jahre Fussboden Blum – Firmengelände mit Festzelt und rotem Firmenfahrzeug" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/rgqh2qxl_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block1-2.jpg", alt: "50 Jahre Fussboden Blum – Gäste beim Empfang auf dem roten Teppich" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/o75urrqu_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block1-3.jpg", alt: "50 Jahre Fussboden Blum – JOKA RoadStore Showtruck" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/a6eid1sk_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block1-4.jpg", alt: "50 Jahre Fussboden Blum – Einstieg in den JOKA RoadStore" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/kvhyhcjp_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block1-5.jpg", alt: "50 Jahre Fussboden Blum – Gäste vor dem JOKA Showtruck" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/m66w395g_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block1-6.jpg", alt: "50 Jahre Fussboden Blum – festlich gedeckte Tafel in der Halle" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/pf0kbquc_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block1-7.jpg", alt: "50 Jahre Fussboden Blum – Gäste beim Sektempfang unter dem Festzelt" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/91ubpe5v_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block1-8.jpg", alt: "50 Jahre Fussboden Blum – Gäste-Paar vor den Festzelt-Schirmen" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/309jpcso_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block1-9.jpg", alt: "50 Jahre Fussboden Blum – Gäste in festlicher Garderobe" },
  ],
  2: [
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/4ij1jby2_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block2-1.jpg", alt: "50 Jahre Fussboden Blum – Firmengründer Emil Blum im Gespräch mit Gästen" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/sja59h8y_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block2-2.jpg", alt: "50 Jahre Fussboden Blum – Jubiläumsdeko mit der Zahl 50 vor den Firmenfahrzeugen" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/h8fo60fx_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block2-3.jpg", alt: "50 Jahre Fussboden Blum – Festrede am Rednerpult" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/11vext7t_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block2-4.jpg", alt: "50 Jahre Fussboden Blum – Grußwort am Rednerpult" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/qbvyygw6_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block2-5.jpg", alt: "50 Jahre Fussboden Blum – Familie mit Nachwuchs beim Empfang" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/b4mdz7yh_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block2-6.jpg", alt: "50 Jahre Fussboden Blum – Gäste vor dem Firmengebäude" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/d9w3ip66_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block2-7.jpg", alt: "50 Jahre Fussboden Blum – Pfarrer und Gast beim Empfang" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/ff3xiwul_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block2-8.jpg", alt: "50 Jahre Fussboden Blum – zwei Gäste im Gespräch" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/j1pvu9lb_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block2-9.jpg", alt: "50 Jahre Fussboden Blum – Gäste-Paar mit Sektglas" },
  ],
  3: [
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/6shzcfg1_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block3-1.jpg", alt: "50 Jahre Fussboden Blum – zwei Gäste vor dem Festzelt" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/7lqv4rql_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block3-2.jpg", alt: "50 Jahre Fussboden Blum – Smart im Parkett-Look mit 50-Jahre-Beklebung" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/5qbadkx9_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block3-3.jpg", alt: "50 Jahre Fussboden Blum – die rote Fahrzeugflotte" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/0g6gj49r_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block3-4.jpg", alt: "50 Jahre Fussboden Blum – Gäste an der Fotowand mit Firmenchronik" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/k7tenbt5_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block3-5.jpg", alt: "50 Jahre Fussboden Blum – Team an der Sekttheke" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/o9i1ct3r_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block3-6.jpg", alt: "50 Jahre Fussboden Blum – Geschenkübergabe an eine Mitarbeiterin" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/nimeu7lf_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block3-7.jpg", alt: "50 Jahre Fussboden Blum – Rede mit Mikrofon am Pult" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/d6qla8dw_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block3-8.jpg", alt: "50 Jahre Fussboden Blum – Gäste in Liegestühlen vor dem JOKA Showtruck" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/fztqbzd7_Fussboden-Blum-50-Jahre-Jubil%C3%A4um-Block3-9.jpg", alt: "50 Jahre Fussboden Blum – Festgruppe mit Konstantin Blum im Festsaal" },
  ],
};

const makeGallery = (g) =>
  Array.from({ length: 9 }, (_, i) =>
    JUBILAEUM_BILDER[g][i] ?? { src: null, alt: `50 Jahre Fussboden Blum – Galerie ${g}, Bild ${i + 1}` }
  );

const GALLERIES = [
  { label: "Eindrücke vom Jubiläum – Teil 1", images: makeGallery(1) },
  { label: "Eindrücke vom Jubiläum – Teil 2", images: makeGallery(2) },
  { label: "Eindrücke vom Jubiläum – Teil 3", images: makeGallery(3) },
];

const HONOREES = [
  { name: "Claus Witzel", years: "10 Jahre" },
  { name: "Waldemar Mosebach", years: "25 Jahre" },
  { name: "Marion Möller", years: "25 Jahre" },
  { name: "Wolfgang Reich", years: "30 Jahre" },
];

/* ---------- Hero ---------- */

const JubilaeumHero = () => (
  <section data-testid="jubilaeum-hero" className="relative min-h-[68vh] flex items-end overflow-hidden">
    <img
      src={IMG.jubilaeumHero}
      alt="Team und Gäste von Fussboden Blum beim 50-jährigen Jubiläum vor dem Firmenfahrzeug"
      className="absolute inset-0 w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#2B2B30]/95 via-[#2B2B30]/55 to-[#2B2B30]/30" />
    <div className="container-blum relative z-10 pb-16 pt-40">
      <Reveal>
        <p data-testid="jubilaeum-hero-script" className="font-script text-3xl lg:text-4xl text-[#D7C4B1]">
          Ein halbes Jahrhundert Handwerk
        </p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.05] tracking-tight mt-3 max-w-3xl">
          50 Jahre Fussboden Blum
        </h1>
        <p className="text-lg text-white/85 mt-5 max-w-2xl leading-relaxed">
          1969–2019: Vom Wohnhaus in der Hofwiese zum zukunftsfähigen Fachbetrieb
          im Mittelkalbacher Gewerbegebiet – gefeiert mit Familie, Team und
          Wegbegleitern.
        </p>
      </Reveal>
    </div>
  </section>
);

/* ---------- Text blocks ---------- */

const Block = ({ overline, title, children, testid }) => (
  <section data-testid={testid} className="py-20 lg:py-28">
    <div className="container-blum max-w-3xl">
      <Reveal><p className="overline">{overline}</p></Reveal>
      <Reveal delay={0.05}>
        <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mt-4 leading-tight">{title}</h2>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="text-[#6B6B73] text-lg leading-relaxed mt-6 space-y-5">{children}</div>
      </Reveal>
    </div>
  </section>
);

const Quote = ({ children, by }) => (
  <blockquote className="border-l-2 border-[#D32F2F] bg-[#F9F8F6] p-6 lg:p-8 my-8">
    <p className="font-display text-lg lg:text-xl text-[#2B2B30] leading-relaxed font-medium">
      {children}
    </p>
    <cite className="block text-sm text-[#6B6B73] not-italic mt-4">{by}</cite>
  </blockquote>
);

/* ---------- Page ---------- */

export default function Jubilaeum() {
  useSeo(
    "50 Jahre Fussboden Blum",
    "50 Jahre Fussboden Blum - 50 Jahre Kompetenz und Handwerk"
  );

  return (
    <div data-testid="jubilaeum-page">
      <Navbar />
      <main>
        <JubilaeumHero />

        <Block
          testid="jubilaeum-block-1"
          overline="Jubiläum 2019"
          title="50 Jahre Fussboden Blum - Tradition und Kontinuität"
        >
          <p>
            1969 gründete Emil Blum in Mittelkalbach Fußboden Blum, damals noch im eigenen
            Wohnhaus. 50 Jahre später ist das Traditionsunternehmen im Gewerbegebiet von
            Mittelkalbach zukunftsfähig aufgestellt, die dritte Generation Blum steht bereits in
            den Startlöchern.
          </p>
          <p>
            Sowohl Björn Hendrischke, Hauptgeschäftsführer der Kreishandwerkerschaft Gießen, als
            auch Dr. Herbert Büttner, Geschäftsführer der Kreishandwerkerschaft Fulda, und Kalbachs
            Bürgermeister Florian Hölzer betonten die Wichtigkeit der Kontinuität im Handwerk:
          </p>
          <Quote by="Björn Hendrischke, Dr. Herbert Büttner und Bürgermeister Florian Hölzer">
            „Es ist heute keine Selbstverständlichkeit mehr, dass ein Handwerksbetrieb 50-jähriges
            Jubiläum feiert. Wir müssen jungen Menschen klar machen, dass unser Handwerk goldenen
            Boden hat, müssen die Flamme weitergeben. Das hat in der Familie Blum mit Sohn
            Konstantin Blum bestens geklappt, aber im Allgemeinen ist in der Hinsicht in unserer
            Branche Luft nach oben: Der Akademisierungswahn führt dazu, dass immer mehr junge
            Menschen studieren, obwohl sie im Handwerk besser aufgehoben wären, Bürokratisierung
            und Überregulierung stellen für Betriebe einen großen Aufwand dar. Deswegen dürfen Sie
            stolz auf das Geleistete sein."
          </Quote>
        </Block>

        <Gallery gallery={GALLERIES[0]} gi={1} testidPrefix="jubilaeum" />

        <Block
          testid="jubilaeum-block-2"
          overline="Rückblick"
          title="Geschichte und Entwicklung des Unternehmens"
        >
          <p>
            Geschäftsführer Michael Blum skizzierte in seiner Rede die Geschichte des Unternehmens:
            Vater Emil Blum erlernte das Handwerk des Bodenlegers in Frankfurt und arbeitete bis
            1969 in der von ihm mitgegründeten Fußbodenabteilung der Firma Damian Werner. Er machte
            sich im Jahr 1969 mit Reinhold Gärtner selbstständig und gründete die Firma Blum und
            Gärtner. Nach knapp zwei Jahren trennten sich beide, jeder gründete seine eigene Firma.
            1973 konnte die Firma Emil Blum vom ursprünglichen Sitz in der Hofwiese 9 in
            Mittelkalbach in ein größeres Gebäude mit angeschlossenem Lager am Blankenbachring 16
            in Mittelkalbach umziehen. 1993 übergab Emil Blum das Unternehmen an Sohn Michael Blum.
            Der Neubau und Umzug ins Mittelkalbacher Gewerbegebiet im Jahr 2003 verschaffte Platz:
            Ein Gebäudekomplex mit insgesamt 850 Quadratmetern Fläche mit umfangreicher Ausstellung,
            angeschlossener Verwaltung und Lagerhalle findet sich vor Ort. Sohn Konstantin ist seit
            1. Januar 2019 als Mitgesellschafter in der Geschäftsführung tätig und kann als
            Parkettleger und studierter Handwerksmanager seine Expertise einbringen.
          </p>
        </Block>

        <Gallery gallery={GALLERIES[1]} gi={2} testidPrefix="jubilaeum" />

        <Block
          testid="jubilaeum-block-3"
          overline="Heute"
          title="Leistungsumfang von Fussboden Blum"
        >
          <p>
            Von der Beratung und Planung über Lieferung, Verlegung bis zur Reinigung, Pflege,
            Sanierung und Aufbereitung der Fußböden reicht das Leistungsspektrum des
            Familienunternehmens, die konsequente Orientierung an den Kundenansprüchen hat
            Branchenerfolge gebracht: Im Jahr 2012 zeichnete der TÜV Rheinland Fußboden Blum als
            erstes Unternehmen in Hessen mit dem TÜV-Siegel „Fachbetrieb für Fußbodentechnik" aus,
            auch eine Auszeichnung für vorbildliche Fortbildungsangebote bestätigt die
            Qualitätsstrategie. Blum, selbst Innungsobermeister der Landesinnung Hessen,
            appellierte am Abend ebenso wie Hendrischke an die Anwesenden, sich für die
            Wiedereinführung der Meisterpflicht der Parkettleger einzusetzen:
          </p>
          <Quote by="Michael Blum, Geschäftsführer und Innungsobermeister der Landesinnung Hessen">
            „Wenn wir keine Meisterpflicht haben, gibt es bald keine Handwerker mehr, die
            ausbilden, die Restaurationsarbeiten durchführen, die sich mit Schadstoffen am Boden
            auskennen, die durch ihr Wissen und ihre Geschicklichkeit unserer Gesellschaft einen
            großen Dienst leisten."
          </Quote>
          <p>
            Neben Ehefrau Regina, als Betriebswirtin des Handwerks selbst im Unternehmen tätig,
            wurden am Abend langjährige verdiente Mitarbeiter geehrt:
          </p>
        </Block>

        <div className="container-blum max-w-3xl -mt-10 pb-20 lg:pb-28">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {HONOREES.map((h, i) => (
              <Reveal key={h.name} delay={i * 0.05}>
                <div data-testid={`honoree-${i}`} className="border border-[#E5E0D8] bg-white p-5 text-center h-full">
                  <p className="font-display text-2xl font-bold text-[#D7C4B1]">{h.years}</p>
                  <p className="text-[#2B2B30] font-medium text-sm mt-1.5">{h.name}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.15}>
            <p className="text-[#6B6B73] text-lg leading-relaxed mt-8">
              Dr. Herbert Büttner überreichte zudem die Jubiläums-Urkunde der Handwerkskammer
              Kassel an die beiden Geschäftsführer.
            </p>
          </Reveal>
        </div>

        <Gallery gallery={GALLERIES[2]} gi={3} testidPrefix="jubilaeum" />
      </main>
      <Footer />
    </div>
  );
}
